import { render } from "./wzselect.vue?vue&type=template&id=11619b54&scoped=true"
import script from "./wzselect.vue?vue&type=script&lang=js"
export * from "./wzselect.vue?vue&type=script&lang=js"

import "./wzselect.vue?vue&type=style&index=0&id=11619b54&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11619b54"]])

export default __exports__